const SPECIAL_DATA = {
  title: ['What makes us special'],
  body: [
    {
      key: 1,
      title: 'Fresh food',
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sollicitudin hendrerit a amet viverra. Nunc pretium in amet at mattis cras.',
      imgSrc: 'assets/special_3.svg'
    },
    {
      key: 2,
      title: 'skilled Chef',
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sollicitudin hendrerit a amet viverra. Nunc pretium in amet at mattis cras.',
      imgSrc: 'assets/special_1.svg'
    },
    {
      key: 3,
      title: 'Exotic dishes',
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sollicitudin hendrerit a amet viverra. Nunc pretium in amet at mattis cras.',
      imgSrc: 'assets/special_2.svg'
    }
  ]
};

export default SPECIAL_DATA;